import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { isFunction } from 'lodash/fp';
import { RowActionsCell } from '../gridCells';
var getReadEditButtonCell = function (actionColumn) {
    return function ReadEditButtonCell(_a) {
        var rowData = _a.rowData, onRowAction = _a.onRowAction;
        var canEdit = isFunction(actionColumn === null || actionColumn === void 0 ? void 0 : actionColumn.canRowEdit) ? actionColumn === null || actionColumn === void 0 ? void 0 : actionColumn.canRowEdit(rowData) : actionColumn === null || actionColumn === void 0 ? void 0 : actionColumn.canRowEdit;
        var canRead = isFunction(actionColumn === null || actionColumn === void 0 ? void 0 : actionColumn.canRowRead) ? actionColumn === null || actionColumn === void 0 ? void 0 : actionColumn.canRowRead(rowData) : actionColumn === null || actionColumn === void 0 ? void 0 : actionColumn.canRowRead;
        // if canEdit and canRead are both true, canEdit supersedes canRead
        var handleOnClick = useCallback(function () {
            var action = canEdit ? 'row_edit' : 'row_read';
            if (onRowAction)
                onRowAction(rowData === null || rowData === void 0 ? void 0 : rowData.id, action, rowData);
        }, [canEdit, onRowAction, rowData]);
        var linkTo = useMemo(function () {
            var _a;
            var mode = canEdit ? 'edit' : 'read';
            return (_a = actionColumn === null || actionColumn === void 0 ? void 0 : actionColumn.createLink) === null || _a === void 0 ? void 0 : _a.call(actionColumn, { mode: mode, id: rowData === null || rowData === void 0 ? void 0 : rowData.id });
        }, [canEdit, rowData === null || rowData === void 0 ? void 0 : rowData.id]);
        if (!canEdit && !canRead)
            return null;
        return _jsx(RowActionsCell, { canEdit: !!canEdit, onClick: handleOnClick, linkTo: linkTo });
    };
};
export default getReadEditButtonCell;
